import React from "react";
import "../css/sidebar.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutAdmin } from "../actions/adminActions";

const navItem = (active, id, to, icon, label) => (
  <Link
    to={to}
    className={`d-flex align-items-center text-decoration-none sidebar-item ${
      active === id ? "active-link" : ""
    }`}
  >
    <i class={`fa-solid me-3 ${icon}`}></i>
    <span>{label}</span>
  </Link>
);

const Sidebar = ({ active }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const adminInfo = useSelector((state) => state.adminInfo);
  const { adminData } = adminInfo;

  const isMaster = adminData?.accessLevel === "Master";

  const handleLogout = () => {
    dispatch(logoutAdmin());
    navigate("/login");
  };

  const initials = adminData?.name
    ? adminData.name
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0])
        .join("")
        .toUpperCase()
    : "?";

  return (
    <div
      className="sidebar text-light"
      style={{
        height: "100vh",
      }}
    >
      <div className="sidebar-brand">
        <img
          src="../images/white.png"
          width="150"
          className="img-fluid d-block"
          alt=""
        />
      </div>

      <div className="sidebar-nav sidebar-links">
        <div className="sidebar-section-label">Menu</div>
        {navItem(active, 2, "/orders", "fa-cart-flatbed", "Orders")}
        {navItem(active, 8, "/warranty", "fa-gears", "Warranty")}
        {navItem(active, 4, "/promocode", "fa-tags", "Promocodes")}

        {isMaster && (
          <>
            <div className="sidebar-section-label">Catalog</div>
            {navItem(active, 3, "/product", "fa-box-open", "Products")}
            {navItem(active, 5, "/addproduct", "fa-plus", "Add Product")}

            <div className="sidebar-section-label">Locations</div>
            {navItem(active, 6, "/store", "fa-store", "Stores")}
            {navItem(active, 7, "/add-store", "fa-plus", "Add Store")}
          </>
        )}

        {/* Not currently linked in navigation, kept reachable by direct URL:
        /create-cart, /prebookings, /notifyme, /testride, /insurance,
        /partner-with-us, /contact */}
      </div>

      {adminData && (
        <div className="sidebar-footer">
          <div className="sidebar-footer-avatar">{initials}</div>
          <div className="flex-grow-1">
            <div className="sidebar-footer-name">{adminData.name}</div>
            <div className="sidebar-footer-role">
              {adminData.accessLevel}
            </div>
          </div>
          <button
            type="button"
            className="sidebar-logout-btn"
            title="Log out"
            onClick={handleLogout}
          >
            <i class="fa-solid fa-right-from-bracket"></i>
          </button>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
